import styled from 'styled-components'

export const DrawingContainer = styled.div`
  border: 1px solid #b9b9b9;
  background: #f8f8f8;
  border-radius: 2px;
  width: 100%;
  min-height: 200px;
`
